import { render, staticRenderFns } from "./EditExternalLink.vue?vue&type=template&id=52e1e008&"
import script from "./EditExternalLink.vue?vue&type=script&lang=js&"
export * from "./EditExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./EditExternalLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports